/**
 * Checks whether an agent is currently active (started but not yet completed).
 * Scans events backward — if AGENT_START is found before any AGENT_COMPLETE, agent is active.
 *
 * @__NO_SIDE_EFFECTS__
 */
export function getIsAgentActive(events) {
    for (let i = events.length - 1; i >= 0; i--) {
        const event = events[i];
        switch (event.type) {
            case 'AGENT_COMPLETE':
                return false;
            case 'AGENT_START':
                return true;
            default:
                break;
        }
    }
    return false;
}
//# sourceMappingURL=getIsAgentActive.js.map